import { Component } from "../component"
import Swiper, { Navigation } from "swiper"

export class SectionFeaturedProducts extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      extended: "-extended",
    }
  }

  ui() {
    return {
      swiperContainer: ".swiper",
      buttonPrev: ".section-featured-products-button-prev",
      buttonNext: ".section-featured-products-button-next",
    }
  }

  initSwiper() {
    const { swiperContainer, buttonPrev, buttonNext } = this.$ui
    const { extended } = this.dynamicClasses
    const isExtended = swiperContainer.classList.contains(extended)
    const windowWidth = Math.min(window.innerWidth, window.screen.width) // to avoid weird scaling bug
    const spaceBetween = windowWidth < 1024 ? 20 : 30
    console.log(buttonPrev, buttonNext)
    const itemsQty = swiperContainer.dataset.itemsQty
      ? parseInt(swiperContainer.dataset.itemsQty)
      : 0

    if (windowWidth < 768) {
      this.swiper = new Swiper(swiperContainer, {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1.3616,
        spaceBetween,
      })
    } else {
      this.swiper = new Swiper(swiperContainer, {
        modules: [Navigation],
        slidesPerView: isExtended ? "auto" : itemsQty,
        spaceBetween,
        loop: true,
        navigation: {
          nextEl: buttonNext,
          prevEl: buttonPrev,
        },
      })
    }
  }

  created() {
    this.initSwiper()
  }
}
